export default "__VITE_ASSET__CPIK301k__"